import IServerOperation from './interface/IServerOperation'
/**
 * 联合
 */
export default class Union extends IServerOperation {
    constructor(serviceUrl, proxyUrl) {
        super('union', serviceUrl, proxyUrl)
    }
}
